'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeDonation = exports.replyToDonation = exports.fetchDonation = undefined;

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

var fetchDonation = exports.fetchDonation = function fetchDonation() {
  return Promise.reject(new Error('This method is not supported by Everydayhero'));
};

var replyToDonation = exports.replyToDonation = function replyToDonation(_ref) {
  var _ref$pageId = _ref.pageId,
      pageId = _ref$pageId === undefined ? (0, _params.required)() : _ref$pageId,
      _ref$donationId = _ref.donationId,
      donationId = _ref$donationId === undefined ? (0, _params.required)() : _ref$donationId,
      _ref$caption = _ref.caption,
      caption = _ref$caption === undefined ? (0, _params.required)() : _ref$caption,
      _ref$token = _ref.token,
      token = _ref$token === undefined ? (0, _params.required)() : _ref$token;

  var headers = { Authorization: 'Bearer ' + token };
  return (0, _client.post)('api/v2/pages/' + pageId + '/donations/' + donationId + '/comments', { caption: caption }, { headers: headers });
};

var deserializeDonation = exports.deserializeDonation = function deserializeDonation(donation) {
  return {
    amount: donation.amount.cents / 100,
    anonymous: donation.anonymous,
    createdAt: donation.created_at,
    currency: donation.amount.currency.iso_code,
    message: donation.message,
    name: donation.nickname,
    page: donation.page_id,
    reply: donation.thankyou_message,
    id: donation.uid
  };
};